import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import { DatePipe } from "@angular/common";
import {config} from "../../../../config";
import {TicketMessage} from "../../model/ticket-message.model";

@Component({
    selector: 'app-chat-dialog',
    imports: [
    DatePipe
],
    templateUrl: './chat-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './chat-dialog.component.scss'
})
export class ChatDialogComponent {
  @Input() message!: TicketMessage;

  public get name(): string {
    return this.message.sender === 'CUSTOMER'
      ? this.message.relation_contact?.name || ''
      : config.companyName;
  }
}
